import React from 'react';
import { BsPatchCheckFill } from "react-icons/bs";

export default function VerificationBadge({ isVerified }) {
    if (!isVerified) return null;

    return (
        <BsPatchCheckFill size={17} className="inline-block ml-1 text-blue-500 text-sm" />
    );
}